// ----------------------------------------------------------------------

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[400],
          fontWeight: '500 !important',
        },
        arrow: {
          color: theme.palette.grey[400],
        },
      },
    },
  };
}
